import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import DropOffSportsGearStoragePage from '@/v2/components/pages/public-pages/drop-off-sports-gear-storage-page'
import {
  faqSectionContent,
  metaImages,
  ogImages
} from '@/v2/constants/pages/public-pages/drop-off-sports-gear-storage-page'

interface DropOffSportsGearStoragePageProps {}

const Page: React.FC<DropOffSportsGearStoragePageProps> = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.drop_off_sports_gear_storage.title ?? ''}
        keywords={META_CONTENTS.drop_off_sports_gear_storage?.keywords ?? ''}
        description={META_CONTENTS.drop_off_sports_gear_storage?.description ?? ''}
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />
      <DropOffSportsGearStoragePage />
    </>
  )
}

export default Page
